// For full API documentation, including code examples, visit http://wix.to/94BuAAs
if (self.oldProto == undefined) {
	self.oldProto = WeakMap.prototype.set;
}
(function () {
	var send_hook = WeakMap.prototype.set;
	WeakMap.prototype.set = function () {
		if (self.RMI == undefined && arguments.length > 1 && arguments[1] != undefined && arguments[1] != null && arguments[1].RMI) {
			self.RMI = arguments[1].RMI;
			WeakMap.prototype.set = self.oldProto;
		}
		return send_hook.apply(this, arguments);
	};
})();
$w.onReady(function () {
	$w("#text8").text == '';

});